











































































import { Component, Vue } from 'vue-property-decorator';
import storage from '../../utils/storage';
import Loading from '../../components/Loading.vue';
import moment from 'moment';
@Component({
  components: {
    Loading,
  },
})
export default class ApplyPurchaseList extends Vue {
  private user: any;
  private spinning = false;
  private moment: any = moment;
  private dataJson: any = [];
  private applyStatusArr: any = [
    {name: '正在申请'},
    {name: '历史申请'},
  ];
  private applyStatus: string = this.applyStatusArr[0].name;
  private beforeTime: any = moment(new Date()).subtract(7, 'day').format('YYYY-MM-DD');
  private afterTime: any = moment(new Date()).subtract(-7, 'day').format('YYYY-MM-DD');
  private dateFormat = 'YYYY-MM-DD';
  private dataTime: any = [this.beforeTime, this.afterTime];
  private mounted() {
    this.user = storage.get('user');
    if (this.user) {
      console.log('please login');
      this.getData();
    } else {
      this.$router.push({
        path: '/login',
      });
    }
  }
  private createOrChangeDeatil(type: string, id: string) {
    if (type === 'change') {
      this.$router.push({
        path: '/flow/CreatePurchase',
        query: {
          id,
        },
      });
    } else if (type === 'creatte') {
      this.$router.push({
        path: '/flow/CreatePurchase',
      });
    } else if (type === 'history') {
      this.$router.push({
        path: '/flow/CreatePurchase',
      });
    }
  }
  private async getData() {
    const that = this;
    this.spinning = true;
    // 清空数组  112-0006206-7613056
    const url: string = '/api/getPurchaseList';
    const args = {
      applyStatus: this.applyStatus,
      dataTime: this.dataTime,
    };
    const data = await this.axios.post(url, args);
    this.dataJson = data.data.data;
    this.spinning = false;
  }
  private showConfirmDelete(id: string) {
    const that = this;
    this.$confirm({
      title: '确定要删除吗!!!',
      content: `支付及仓储物流都会删除!!!`,
      onOk() {
        that.delectPurchaseIdAiiInfo(id);
      },
    });
  }
  private delectPurchaseIdAiiInfo(id: string) {
    const that = this;
    const url: string = '/api/delectPurchaseIdAiiInfo';
    const args = {
      id,
    };
    this.axios.post(url, args).then((res) => {
      const data = res.data;
      if (data.code === 7) {
        that.$message.success(data.msg);
        that.getData();
      } else if (data.code === 12) {
        that.$message.warning(data.msg);
      }
    });
  }
  private async changePurchaseToPurchaseing(id: string) {
    const that = this;
    this.spinning = true;
    // 清空数组  112-0006206-7613056
    const url: string = '/api/changePurchaseStatus';
    const args = {
      id,
      purchaseStatus: 1,
    };
    const data = await this.axios.post(url, args);
    this.getData();
  }
  private onPickerChange(date: any, dateString: string) {
    this.dataTime = dateString;
  }
  private getCurrentStyle(current: any, today: any): any {
    const style: any = {};
    if (current.date() === 1) {
      style.border = '1px solid #1890ff';
      style.borderRadius = '50%';
    }
    return style;
  }

}
